import get from 'lodash.get';

const getPages = (rootState) => get(rootState, 'ws.site.meta.pages', []);

export default getPages;
